export const users = () => (
  <path
    d="M20 21a3 3 0 100-6M16 3.13a4 4 0 010 7.75M4 21a3 3 0 110-6h10a3 3 0 110 6H4zm9-14a4 4 0 11-8 0 4 4 0 018 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
